<template>
  <form novalidate>
    <h4 class="h4">Ubicación del evento de depredación</h4>
    <div class="form__group">
      <label class="form__label form__label--required">
        Ubicación del sitio del ataque (en este momento asegúrese de estar ubicado en el
        sitio exacto donde fue el ataque y proceda a actualizar su ubicación haciendo
        click en el ícono de ubicación)
      </label>
      <button v-if="cargandoUbicacion" disabled class="boton boton--primario boton--s">
        <i class="fa fa-spinner fa-spin" />
      </button>
      <button v-else :disabled="!editando" type="button"
      class="boton boton--ubicacion boton--s" @click="obtenerPosicion"/>
      <form-group :error="errors.has('gps-longitud') && submitted">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        class="form__input"
        type="number"
        required
        max="180"
        min="-180"
        name="gps-longitud"
        v-validate="['required', 'max_value:180', 'min_value:-180']"
        v-model.number="form.pos.coordinates[0]">
        <label class="form__label">Longitud (-180 a 180)</label>
      </form-group>
      <form-group :error="errors.has('gps-latitud') && submitted">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        class="form__input"
        type="number"
        required
        max="90"
        min="-90"
        name="gps-latitud"
        v-validate="['required', 'max_value:90', 'min_value:-90']"
        v-model.number="form.pos.coordinates[1]">
        <label class="form__label">Latitud (-90 a 90)</label>
      </form-group>
    </div>
  </form>
</template>

<script>
import moment from "moment";

export default {
  name: "FormGPS",
  data() {
    return {
      cargandoUbicacion: false,
    };
  },
  props: {
    submitted: Boolean,
    form: Object,
    editando: Boolean,
  },
  methods: {
    obtenerPosicion,
    validar,
  },
};

function obtenerPosicion() {
  this.cargandoUbicacion = true;
  return navigator.geolocation.getCurrentPosition(
    (pos) => {
      this.form.pos.coordinates = [pos.coords.latitude, pos.coords.longitude];
      this.form.fechaCapturaCoordenadas = moment();
      this.cargandoUbicacion = false;
    },
    (error) => {
      const mensaje = obtenerMensajeError(error);
      this.cargandoUbicacion = false;
      this.$store.commit(this.$actions.showModal, {
        componentName: "errorGeolocation",
        params: {
          grande: true,
          mensaje,
          continuar: () => {
            this.form.pos.coordinates = [0, 0];
            this.$nextTick(() => {
              this.$parent.$refs.botonSiguiente.click();
            });
          },
        },
      });
    },
    {
      timeout: 5000,
      enableHighAccuracy: true,
    },
  );
}

function validar() {
  return this.$validator.validate();
}

function obtenerMensajeError(error) {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      return "Permiso para obtener ubicación denegado. Asegúrese de tener el GPS activado.";
    case error.POSITION_UNAVAILABLE:
      return "Los datos de ubicación no están disponibles en este momento.";
    case error.TIMEOUT:
      return "El tiempo de espera para obtener la ubicación se ha agotado.";
    case error.UNKNOWN_ERROR:
      return "Ha ocurrido un error desconocido al tratar de obtener la ubicación.";
    default:
      return "";
  }
}
</script>
